import React from 'react'
import MatchChart from 'lib/components/charts/match-chart'
import Container from 'lib/components/charts/container'
import XAxis from 'lib/components/charts/x-axis'
import YAxis from 'lib/components/charts/y-axis'
import Grid from 'lib/components/charts/grid'
import SmallLabelXAxis from 'lib/components/charts/small-label-x-axis'
import SparkLine from 'lib/components/charts/shapes/spark-line'
import Title from './title'
import LineChartTooltip from 'lib/components/charts/line-chart-tooltip'
import { asDecimalPercent, asFullYear } from 'lib/format'
import { scaleLinear, scaleTime } from 'd3-scale'
import { extent } from 'd3-array'
import { getGutters } from 'lib/components/charts/layouts/gutters'

class ModelHistory extends React.PureComponent {
  static defaultProps = {
    datasets: [],
    width: 300,
    height: 225,
    formatX: asFullYear,
    formatY: n => n,
    labelX: 'Year',
    labelY: ''
  }

  renderLine(x, y, { key, points, label, color }) {
    return (
      <SparkLine
        key={key}
        points={points}
        scaleX={x}
        scaleY={y}
        label={label}
        stroke={color}
      />
    )
  }

  getDomainX() {
    let values = this.props.datasets.reduce((memo, dataset) => {
      return memo.concat(dataset.points.map(point => point.x))
    }, [])

    return values.length ? extent(values) : [new Date(0), new Date()]
  }

  getDomainY() {
    let values = this.props.datasets.reduce((memo, dataset) => {
      return memo.concat(dataset.points.map(point => point.y))
    }, [])

    return values.length ? extent(values) : []
  }

  render() {
    const {
      datasets,
      labelX,
      labelY,
      labelLine1,
      labelLine2,
      title,
      formatX,
      formatY,
      width,
      height
    } = this.props

    const period = this.getDomainX()

    const x = scaleTime()
      .domain(period)
      .nice(8)

    const y = scaleLinear().nice(4)

    if (period.length) {
      y.domain(this.getDomainY()).nice(4)
    }

    let { left, top, bottom, right } = getGutters({
      width: width,
      height: height,
      left: {
        ticks: y.ticks(4),
        format: formatY,
        label: labelY.toUpperCase()
      },
      bottom: {
        ticks: x.ticks(4),
        format: formatX,
        label: labelX.toUpperCase()
      }
    })

    x.range([left, width - right])
    y.range([height - bottom, top])

    return (
      <Container width={width} height={height}>
        <Grid scaleX={x} scaleY={y} ticksX={x.ticks()} ticksY={y.ticks(4)} />

        <Title x={left} y={top}>
          {title}
        </Title>

        {datasets.map(dataset => this.renderLine(x, y, dataset))}

        <MatchChart breakpoint="large" width={width}>
          <XAxis
            label={labelX}
            scale={x}
            format={formatX}
            ticks={x.ticks()}
            height={bottom}
            y={y.range()[0]}
          />
        </MatchChart>

        <MatchChart breakpoint="small" width={width}>
          <SmallLabelXAxis
            label={period.map(formatX).join(' - ')}
            x={left}
            y={height - bottom}
            width={width - right}
          />
        </MatchChart>

        <YAxis
          label={labelY}
          scale={y}
          format={formatY}
          ticks={y.ticks(4)}
          height={height}
          width={left}
        />

        {/* TODO: what should labelY2 be here? */}
        {this.props.expanded && (
          <LineChartTooltip
            label="Model History"
            datasets={datasets}
            formatY1={asDecimalPercent(2)}
            formatY2={asDecimalPercent(2)}
            labelY1={labelLine1}
            labelY2={labelLine2}
            width={width}
            height={height}
            left={left}
            top={top}
            bottom={bottom}
            right={right}
            scaleX={x}
            scaleY1={y}
            scaleY2={y}
          />
        )}
      </Container>
    )
  }
}

export default ModelHistory



// WEBPACK FOOTER //
// ./src/components/charts/model-history.js